module.exports = __webpack_public_path__ + "img/bim (9).e124d23b.png";